import { useTranslation } from 'react-i18next'

import {
  useIsBuildingGroupProfileNGAvailable,
  useNotification,
} from '../../../../hooks'
import { getBuildingGroupCreationSuccessNotification } from '../../BuildingGroup.utils'
import { BuildingGroupFormModal } from '../../BuildingGroupFormModal'

export function useCreateBuildingGroup({ setModal, onClose, onReload }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const isBuildingGroupProfileNGAvailable =
    useIsBuildingGroupProfileNGAvailable()

  function handleSuccess(data) {
    onClose()

    handleAddSuccessNotification(
      getBuildingGroupCreationSuccessNotification({
        data,
        isBuildingGroupProfileNGAvailable,
        t,
      })
    )

    onReload?.()
  }

  function handleOpenCreation() {
    setModal(
      <BuildingGroupFormModal onClose={onClose} onSuccess={handleSuccess} />
    )
  }

  return {
    handleOpenCreation,
  }
}
